import React from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { SwitchIndicator } from "@design-system/Switch/SwitchIndicator";
import { FilterProps } from "./lib";
import styles from "./TransactionActionsToggleFilter.module.scss";

export const TransactionActionsToggleFilter: React.FC<FilterProps> = ({
    filters,
    onChange,
}) => {
    const isActive = !!filters.requiredAction;

    let tooltipText: React.ReactNode;

    if (isActive) {
        tooltipText = <>Turn Off to view all your transactions.</>;
    } else {
        tooltipText = <>Turn on to only view transactions with actions.</>;
    }

    return (
        <Tooltip content={tooltipText}>
            <button
                type="button"
                role="switch"
                aria-checked={isActive}
                className={styles.filter}
                onClick={() => onChange({ requiredAction: !isActive })}
            >
                <SwitchIndicator checked={isActive} />
                Actions
            </button>
        </Tooltip>
    );
};
